import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ExperienceRibbon } from '../components/ExperienceRibbon';
import { CulinaryGrid } from '../components/CulinaryGrid';
import { StorySection } from '../components/StorySection';
import { SocialTicker } from '../components/SocialTicker';
interface HomeProps {
  onNavigate: (page: string) => void;
}
export function Home({
  onNavigate
}: HomeProps) {
  return <main data-id="element-509">
      <HeroSection data-id="element-510" />
      <ExperienceRibbon onNavigate={onNavigate} data-id="element-511" />
      <CulinaryGrid data-id="element-512" />
      <StorySection data-id="element-513" />
      <SocialTicker data-id="element-514" />
    </main>;
}